export const statusEnum = {
  0: 'Redeemed',
  1: 'Applied',
  2: 'Expired',
  3: 'Failed',
  4: 'Pending',
  6: 'Forfeited',
}

export const statusDeliveryEnum = {
  0: 'Redeemed',
  1: 'Shipped',
  2: 'Rejected',
  3: 'Shipped', // Completed but display shipped
  4: 'LowInventory',
  5: 'Redeemed' // Processing but display Redeemed
}

export const rewardTypeEnum = {
  0: 'Cash Rebate',
  1: 'Loss Rescue',
  2: 'Deposit Discount',
  3: 'Profit Booster',
}

export const rewardType = {
  CASH_REBATE: rewardTypeEnum[0],
  LOSS_RESCUE: rewardTypeEnum[1],
  DEPOSIT_DISCOUNT: rewardTypeEnum[2],
  PROFIT_BOOSTER: rewardTypeEnum[3],
}

export const REWARD_TNC = {
  0: 'https://www.vtmarkets.com/clubbleu_direct_cash',
  1: 'https://www.vtmarkets.com/clubbleu_loss_rescue',
  2: 'https://www.vtmarkets.com/clubbleu_deposit_discount',
  3: 'https://www.vtmarkets.com/clubbleu_profit_booster',
  giftShop: 'https://www.vtmarkets.com/vt-markets-gift-shop/',
}
